import DownloadIcon from "./download"

const icons: { [key:string]: any } = {
  Download: DownloadIcon,
}

export type IconType = 'Download' | '';

export const renderIcon = (type: IconType | undefined, props: Object) => {
  if (!type) return null;

  const Component = icons[type];

  return <Component {...props} />;
}